import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from '../../../shared/services/api.service';

@Component({
  selector: 'app-license-request-verification',
  templateUrl: './license-request-verification.component.html',
  styleUrls: ['./license-request-verification.component.scss']
})
export class LicenseRequestVerificationComponent implements OnInit {

  loading: boolean = true;
  error: string | null = null;

  token: string | null = null;
  action: string | null = null;

  itemData: any = null;
  jobUuid: string = '';
  imageUuid: string = '';

  processing: boolean = false;
  message: string = '';

  constructor(
    private route: ActivatedRoute,
    private apiService: ApiService
  ) {}

  ngOnInit(): void {
    // 🟢 IMPORTANT FIX: decode token correctly
    const rawToken = this.route.snapshot.queryParamMap.get('token');
    this.token = rawToken ? decodeURIComponent(rawToken) : null;

    this.action = this.route.snapshot.queryParamMap.get('action');

    if (!this.token) {
      this.error = "Invalid or missing token.";
      this.loading = false;
      return;
    }

    this.verifyToken();
  }

  // -----------------------------------------
  // 1️⃣ Verify Token
  // -----------------------------------------
  verifyToken() {
    const payload = { token: this.token };

    this.apiService.verifyLicenseToken(payload).subscribe({
      next: (res: any) => {
        this.loading = false;

        this.itemData = res.data;
        this.jobUuid = res.data.job_uuid;
        this.imageUuid = res.data.image_uuid;
      },
      error: (err) => {
        this.loading = false;
        this.error = err.error?.error || "Failed to validate token.";
      }
    });
  }

  // -----------------------------------------
  // 2️⃣ Approve / Decline Request
  // -----------------------------------------
  processRequest(finalAction: 'approve' | 'decline') {

    const confirmMsg =
      finalAction === 'approve'
        ? "Are you sure you want to APPROVE this license?"
        : "Are you sure you want to DECLINE this license?";

    const confirmed = confirm(confirmMsg);
    if (!confirmed) return;

    this.processing = true;

    const payload = {
      token: this.token,
      action: finalAction
    };

    this.apiService.processLicenseAction(payload).subscribe({
      next: (res: any) => {
        this.processing = false;
        this.message = res.message;
      },
      error: (err) => {
        this.processing = false;
        this.error = err.error?.error || "Action failed.";
      }
    });
  }
}
